"use strict";
exports.__esModule = true;
exports.SvgFileAttachmentsMsWord = void 0;
var tslib_1 = require("tslib");
/**
 * This file is generated from 'npm run build-svg'. Any changes should be made to the
 * template in .svgrrc.js or to the source SVG in src/icons/svg.
 **/
var react_1 = tslib_1.__importDefault(require("react"));
exports.SvgFileAttachmentsMsWord = function (props) { return (react_1["default"].createElement("svg", tslib_1.__assign({ viewBox: "0 0 20 20" }, props),
    react_1["default"].createElement("g", { fillRule: "nonzero", fill: "none" },
        react_1["default"].createElement("path", { fill: "#185ABD", d: "M1.667 0h16.666c.442 0 .866.176 1.179.488.312.313.488.737.488 1.179v16.666c0 .442-.176.866-.488 1.179a1.67 1.67 0 01-1.179.488H1.667C.747 20 0 19.254 0 18.333V1.667C0 .747.746 0 1.667 0z" }),
        react_1["default"].createElement("path", { fill: "#FFF", d: "M14.149 15h-1.891l-2.205-6.9L7.742 15H5.851L3.75 5h1.891l1.47 7 2.206-6.8h1.576l2.101 6.8 1.47-7h1.786z" })))); };
//# sourceMappingURL=FileAttachmentsMsWord.js.map